/* Ignacio - ADA Drawer: Compatible with tab and focused when adding a product to cart */
document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.querySelector("#Cart-Drawer");

  // Handle product card "Add to Cart" buttons
  const addToCartButtons = document.querySelectorAll(
    ".product-card--add-to-cart-button"
  );
  addToCartButtons.forEach((button) => {
    button.addEventListener("click", async (e) => {
      if (
        button.classList.contains("product-card--add-to-cart-button-simple")
      ) {
        const productId = button.getAttribute("data-product-id");
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: productId, quantity: 1 }),
        });

        if (response.ok) {
          cartDrawer.classList.add("active");
          cartDrawer.setAttribute("tabindex", "0");
          cartDrawer.focus();
          cartDrawer.setAttribute("aria-live", "polite");
          cartDrawer.setAttribute(
            "aria-label",
            "Shopping cart updated with new item"
          );
        }
      }
    });
  });

  // Handle single product page "Add to Cart" button
  const singleAddToCartButton = document.querySelector("#AddToCart");
  if (singleAddToCartButton) {
    singleAddToCartButton.addEventListener("click", async (e) => {
      // Assuming this button is part of a form with variant ID
      const form = singleAddToCartButton.closest("form");
      const variantId = form.querySelector('input[name="id"]').value;

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (response.ok) {
        cartDrawer.classList.add("active");
        cartDrawer.setAttribute("tabindex", "0");
        cartDrawer.focus();
        cartDrawer.setAttribute("aria-live", "polite");
        cartDrawer.setAttribute(
          "aria-label",
          "Shopping cart updated with new item"
        );
      }
    });
  }

  // Close button logic
  const closeButton = document.querySelector(".side-panel-close");
  closeButton?.addEventListener("click", () => {
    cartDrawer.classList.remove("active");
    cartDrawer.setAttribute("tabindex", "-1");
  });
});